// @ts-nocheck
/* eslint-disable no-return-assign */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-plusplus */
/* eslint-disable no-undef */
import { css, html } from 'lit';
import { i18n } from '@lingui/core';
import WarpElement from '@warp-ds/elements-core';

/**
 * Temporary beta bar component for the Aurora rollout programs.
 */
class BetaBar extends WarpElement {
    constructor() {
        super();

        this._translationSupport = false;
    }

    get messages() {
        return this.getAttribute('messages')
            ? JSON.parse(this.getAttribute('messages' || '{}'))
            : {};
    }

    get i18n() {
        if (!this._translationSupport) {
            i18n.load(this.locale, this.messages);
            i18n.activate(this.locale);
        }

        return i18n;
    }

    get locale() {
        return this.getAttribute('locale') || 'nb';
    }

    get brand() {
        return this.getAttribute('brand') || 'FINN';
    }

    get links() {
        return this.getAttribute('links')
            ? JSON.parse(this.getAttribute('links' || {}))
            : {};
    }

    static get styles() {
        return [
            ...WarpElement.styles,
            css`
                :host {
                    display: block;
                    margin-top: -16px;
                    margin-bottom: 32px;
                }
                @media print {
                    .beta-bar {
                        position: static !important;
                    }
                }

                *,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0;box-sizing:border-box;border-style:solid;border-width:0;border-color:var(--w-s-color-border,var(--w-s-color-border-default))}html{font-size:62.5%}body{background-color:var(--w-s-color-background,var(--w-s-color-background-default));min-height:100%;margin:0;overflow-y:scroll}body,:host{-webkit-text-size-adjust:100%;tab-size:4;-webkit-tap-highlight-color:transparent;font-family:var(--w-font-family);font-size:var(--w-font-size-m);line-height:var(--w-line-height-m);color:var(--w-s-color-text,var(--w-s-color-text-default))}hr{color:inherit;border-top-width:1px;height:0}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:700}a{cursor:pointer;color:var(--w-s-color-text-link);text-decoration:none}a:hover,a:focus,a:active{-webkit-text-decoration:var(--w-decoration-text-link);-webkit-text-decoration:var(--w-decoration-text-link);text-decoration:var(--w-decoration-text-link)}b,strong{font-weight:700}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:1em}sub,sup{vertical-align:baseline;font-size:75%;line-height:0;position:relative}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button{height:auto}::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{margin:0;padding:0;list-style:none}textarea{resize:vertical}input::placeholder,textarea::placeholder{opacity:1;color:var(--w-s-color-text-placeholder)}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{vertical-align:middle;display:block}img,video{max-width:100%;height:auto}h1{font-size:var(--w-font-size-xxl);line-height:var(--w-line-height-xxl)}h2{font-size:var(--w-font-size-xl);line-height:var(--w-line-height-xl)}h3{font-size:var(--w-font-size-l);line-height:var(--w-line-height-l)}h4{font-size:var(--w-font-size-m);line-height:var(--w-line-height-m)}h5{font-size:var(--w-font-size-s);line-height:var(--w-line-height-s)}dt,dd{margin:0 16px}h1,h2,h3,h4,h5,ul,ol,dl,p,blockquote{margin:0 0 8px}[hidden]{display:none!important}[tabindex="-1"]:focus:not(:focus-visible){outline:none}legend{float:left;width:100%;margin:0;padding:0;display:table}legend+*{clear:both}fieldset{border:0;min-width:0;margin:0;padding:.01em 0 0}body:not(:-moz-handler-blocked) fieldset{display:table-cell}.page-container{background-color:var(--w-s-color-background);max-width:1010px;margin:0;padding:0 16px}.text-detail{font-size:var(--w-font-size-xs);line-height:var(--w-line-height-xs)}@media (min-width:1300px){.page-container{margin-left:auto;margin-right:auto;padding-left:31px;padding-right:31px}}.block{display:block}.flex{display:flex}.underline{text-decoration-line:underline}.flex-1{flex:1}.items-center{align-items:center}.static{position:static}.z-20{z-index:20}.s-bg-primary{background-color:var(--w-s-color-background-primary)}.s-text-inverted{color:var(--w-s-color-text-inverted)}.w-full{width:100%}.m-0{margin:0}.mr-8{margin-right:.8rem}.py-8{padding-top:.8rem;padding-bottom:.8rem}@media (min-width:768px){.md\\:mr-16{margin-right:1.6rem}};
            `,
        ];
    }

    static get properties() {
        return {
            loggedIn: { type: Boolean, attribute: 'logged-in' },
            show: { type: Boolean, reflect: true },
        };
    }

    connectedCallback() {
        super.connectedCallback();
    }

    get _origin() {
        if (this.sites) return this.sites;
        return new URL(this.baseURI).origin;
    }

    render() {
        if (this.brand !== 'TORI') return html``;
        // Renders the beta bar, with an additional wrapper to make it work with the page-container
        return html`<div class="s-bg-primary">
            <div
                class="page-container z-20 s-bg-primary py-8 flex w-full items-center"
            >
                <p class="text-detail s-text-inverted m-0 flex-1 mr-8">
                    ${this.i18n.t({
                        id: 'topbar.header.frontpage.betabar.title',
                        message: 'Beta of new Tori',
                        comment:
                            'Information text on using the Tori beta to be displayed above the header',
                    })}
                </p>
                <a
                    class="text-detail s-text-inverted underline mr-8 md:mr-16"
                    href="${this.links.betaAbout}"
                    >${this.i18n.t({
                        id: 'topbar.header.frontpage.betabar.about.link',
                        message: 'Beta info',
                        comment:
                            'Link text for the about Beta information linke',
                    })}</a
                >
                <a
                    class="text-detail s-text-inverted underline"
                    href="${this.links.betaFeedback}"
                    >${this.i18n.t({
                        id: 'topbar.header.frontpage.betabar.feedback.link',
                        message: 'Feedback',
                        comment: 'Link text for the feedback link on the Beta',
                    })}</a
                >
            </div>
        </div>`;
    }
}
if (!customElements.get('beta-bar')) {
    customElements.define('beta-bar', BetaBar);
}
